import { ThemeMain } from 'themes/types/theme.types';
import { themeApp } from './themeApp/themeApp';
import { themeUi } from './themeUi/themeUi';

export const theme: ThemeMain = {
  ...themeUi,
  ...themeApp
};
